import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Yaroslav Bandura
 * id 5458AB97-471F-4A96-92E0-FB0AE72AFF33
 * name format-list-text
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-list-text.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatListTextIcon = createSvgIcon(<><path d="M2 14H8V20H2M16 8H10V10H16M2 10H8V4H2M10 4V6H22V4M10 20H16V18H10M10 16H22V14H10" /></>, 'FormatListTextIcon');
export default FormatListTextIcon